export default __webpack_public_path__ + "static/1930_1940-5eda31a4961a930c35afce79234dc430.mp4";